/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminBroadcastCAChatBody } from '../models';
// @ts-ignore
import type { AdminSendCAChatBody } from '../models';
// @ts-ignore
import type { BroadcastCABody } from '../models';
// @ts-ignore
import type { CABroadcastResponse } from '../models';
// @ts-ignore
import type { CABroadcastResultResponse } from '../models';
// @ts-ignore
import type { CACallResponse } from '../models';
// @ts-ignore
import type { CACallTemplateBody } from '../models';
// @ts-ignore
import type { CACallTemplateListResponse } from '../models';
// @ts-ignore
import type { CACallTemplateResponse } from '../models';
// @ts-ignore
import type { CAParticipantChatBlockedResponse } from '../models';
// @ts-ignore
import type { CASendCAChatResponse } from '../models';
// @ts-ignore
import type { CancelCACallBody } from '../models';
// @ts-ignore
import type { CreateCACohortBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FinalizeSelectionBody } from '../models';
// @ts-ignore
import type { GetCAAnnouncementsResponse } from '../models';
// @ts-ignore
import type { GetCAChatMessagesResponse } from '../models';
// @ts-ignore
import type { GetCAChatThreadsResponse } from '../models';
// @ts-ignore
import type { GetCACohortListResponse } from '../models';
// @ts-ignore
import type { GetCACohortResponse } from '../models';
// @ts-ignore
import type { GetCALeaderboardResponse } from '../models';
// @ts-ignore
import type { GetCAParticipantListResponse } from '../models';
// @ts-ignore
import type { NudgeParticipantBody } from '../models';
// @ts-ignore
import type { ScheduleCACallBody } from '../models';
// @ts-ignore
import type { SendCAAvailabilityBody } from '../models';
// @ts-ignore
import type { SendCAAvailabilityResponse } from '../models';
// @ts-ignore
import type { SendSelectionMessagesBody } from '../models';
// @ts-ignore
import type { SendTestWhatsappBody } from '../models';
// @ts-ignore
import type { SetChatBlockedBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateCAAnnouncementBody } from '../models';
// @ts-ignore
import type { UpdateCAAnnouncementResponse } from '../models';
// @ts-ignore
import type { UpdateCACohortBody } from '../models';
// @ts-ignore
import type { UpdateCAParticipantStatusBody } from '../models';
// @ts-ignore
import type { UpdateCAParticipantTargetBody } from '../models';
/**
 * AdminCaApiApi - axios parameter creator
 */
export const AdminCaApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdminBroadcastCAChatBody} adminBroadcastCAChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiAdminBroadcastCaChat: async (adminBroadcastCAChatBody: AdminBroadcastCAChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminBroadcastCAChatBody' is not null or undefined
            assertParamExists('adminCaApiAdminBroadcastCaChat', 'adminBroadcastCAChatBody', adminBroadcastCAChatBody)
            const localVarPath = `/admin/campus-ambassador/chat/broadcast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminBroadcastCAChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminSendCAChatBody} adminSendCAChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiAdminSendCaChat: async (adminSendCAChatBody: AdminSendCAChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSendCAChatBody' is not null or undefined
            assertParamExists('adminCaApiAdminSendCaChat', 'adminSendCAChatBody', adminSendCAChatBody)
            const localVarPath = `/admin/campus-ambassador/chat/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSendCAChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {BroadcastCABody} broadcastCABody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiBroadcastCa: async (cohortId: string, broadcastCABody: BroadcastCABody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiBroadcastCa', 'cohortId', cohortId)
            // verify required parameter 'broadcastCABody' is not null or undefined
            assertParamExists('adminCaApiBroadcastCa', 'broadcastCABody', broadcastCABody)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/broadcast`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(broadcastCABody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {CancelCACallBody} cancelCACallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCancelCaCall: async (interviewId: string, cancelCACallBody: CancelCACallBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interviewId' is not null or undefined
            assertParamExists('adminCaApiCancelCaCall', 'interviewId', interviewId)
            // verify required parameter 'cancelCACallBody' is not null or undefined
            assertParamExists('adminCaApiCancelCaCall', 'cancelCACallBody', cancelCACallBody)
            const localVarPath = `/admin/campus-ambassador/call/{interview_id}/cancel`
                .replace('{interview_id}', encodeURIComponent(String(interviewId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelCACallBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCloseApplications: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiCloseApplications', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/close-applications`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CACallTemplateBody} cACallTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCreateCaCallTemplate: async (cACallTemplateBody: CACallTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cACallTemplateBody' is not null or undefined
            assertParamExists('adminCaApiCreateCaCallTemplate', 'cACallTemplateBody', cACallTemplateBody)
            const localVarPath = `/admin/campus-ambassador/call/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cACallTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCACohortBody} createCACohortBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCreateCohort: async (createCACohortBody: CreateCACohortBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCACohortBody' is not null or undefined
            assertParamExists('adminCaApiCreateCohort', 'createCACohortBody', createCACohortBody)
            const localVarPath = `/admin/campus-ambassador/cohort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCACohortBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiDeleteCaCallTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('adminCaApiDeleteCaCallTemplate', 'templateId', templateId)
            const localVarPath = `/admin/campus-ambassador/call/template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiDeleteCohort: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiDeleteCohort', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {FinalizeSelectionBody} finalizeSelectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiFinalizeSelection: async (cohortId: string, finalizeSelectionBody: FinalizeSelectionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiFinalizeSelection', 'cohortId', cohortId)
            // verify required parameter 'finalizeSelectionBody' is not null or undefined
            assertParamExists('adminCaApiFinalizeSelection', 'finalizeSelectionBody', finalizeSelectionBody)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/finalize-selection`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalizeSelectionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} caChatId 
         * @param {string | null} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiGetCaChatMessagesAdmin: async (caChatId: string, cursor?: string | null, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caChatId' is not null or undefined
            assertParamExists('adminCaApiGetCaChatMessagesAdmin', 'caChatId', caChatId)
            const localVarPath = `/admin/campus-ambassador/chat/{ca_chat_id}/messages`
                .replace('{ca_chat_id}', encodeURIComponent(String(caChatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiGetCohort: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiGetCohort', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCaCallTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/campus-ambassador/call/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCaChatThreads: async (cohortId: string, page?: number, pageSize?: number, search?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiListCaChatThreads', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/chat/threads`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCohortAnnouncements: async (cohortId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiListCohortAnnouncements', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/announcements`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCohortApplicants: async (cohortId: string, page?: number, pageSize?: number, status?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiListCohortApplicants', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/applicants`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCohorts: async (page?: number, pageSize?: number, status?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/campus-ambassador/cohort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} participantId 
         * @param {NudgeParticipantBody} nudgeParticipantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiNudgeParticipant: async (participantId: string, nudgeParticipantBody: NudgeParticipantBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('adminCaApiNudgeParticipant', 'participantId', participantId)
            // verify required parameter 'nudgeParticipantBody' is not null or undefined
            assertParamExists('adminCaApiNudgeParticipant', 'nudgeParticipantBody', nudgeParticipantBody)
            const localVarPath = `/admin/campus-ambassador/participant/{participant_id}/nudge`
                .replace('{participant_id}', encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nudgeParticipantBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiOpenApplications: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiOpenApplications', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/open-applications`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiOverallLeaderboardAdmin: async (cohortId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiOverallLeaderboardAdmin', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/leaderboard`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ScheduleCACallBody} scheduleCACallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiScheduleCaCall: async (scheduleCACallBody: ScheduleCACallBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleCACallBody' is not null or undefined
            assertParamExists('adminCaApiScheduleCaCall', 'scheduleCACallBody', scheduleCACallBody)
            const localVarPath = `/admin/campus-ambassador/call/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleCACallBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiScoreCohortApplicants: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiScoreCohortApplicants', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/score-applicants`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendCAAvailabilityBody} sendCAAvailabilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendCaAvailability: async (sendCAAvailabilityBody: SendCAAvailabilityBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendCAAvailabilityBody' is not null or undefined
            assertParamExists('adminCaApiSendCaAvailability', 'sendCAAvailabilityBody', sendCAAvailabilityBody)
            const localVarPath = `/admin/campus-ambassador/call/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendCAAvailabilityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {SendSelectionMessagesBody} sendSelectionMessagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendSelectionEmails: async (cohortId: string, sendSelectionMessagesBody: SendSelectionMessagesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiSendSelectionEmails', 'cohortId', cohortId)
            // verify required parameter 'sendSelectionMessagesBody' is not null or undefined
            assertParamExists('adminCaApiSendSelectionEmails', 'sendSelectionMessagesBody', sendSelectionMessagesBody)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/send-selection-emails`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSelectionMessagesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {SendSelectionMessagesBody} sendSelectionMessagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendSelectionWhatsapp: async (cohortId: string, sendSelectionMessagesBody: SendSelectionMessagesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiSendSelectionWhatsapp', 'cohortId', cohortId)
            // verify required parameter 'sendSelectionMessagesBody' is not null or undefined
            assertParamExists('adminCaApiSendSelectionWhatsapp', 'sendSelectionMessagesBody', sendSelectionMessagesBody)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/send-selection-whatsapp`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSelectionMessagesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendTestWhatsappBody} sendTestWhatsappBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendTestWhatsapp: async (sendTestWhatsappBody: SendTestWhatsappBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendTestWhatsappBody' is not null or undefined
            assertParamExists('adminCaApiSendTestWhatsapp', 'sendTestWhatsappBody', sendTestWhatsappBody)
            const localVarPath = `/admin/campus-ambassador/send-test-whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTestWhatsappBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {UpdateCAParticipantTargetBody} updateCAParticipantTargetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSetCohortCertificateTarget: async (cohortId: string, updateCAParticipantTargetBody: UpdateCAParticipantTargetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiSetCohortCertificateTarget', 'cohortId', cohortId)
            // verify required parameter 'updateCAParticipantTargetBody' is not null or undefined
            assertParamExists('adminCaApiSetCohortCertificateTarget', 'updateCAParticipantTargetBody', updateCAParticipantTargetBody)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/certificate-target`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCAParticipantTargetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} participantId 
         * @param {UpdateCAParticipantTargetBody} updateCAParticipantTargetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSetParticipantCertificateTarget: async (participantId: string, updateCAParticipantTargetBody: UpdateCAParticipantTargetBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('adminCaApiSetParticipantCertificateTarget', 'participantId', participantId)
            // verify required parameter 'updateCAParticipantTargetBody' is not null or undefined
            assertParamExists('adminCaApiSetParticipantCertificateTarget', 'updateCAParticipantTargetBody', updateCAParticipantTargetBody)
            const localVarPath = `/admin/campus-ambassador/participant/{participant_id}/certificate-target`
                .replace('{participant_id}', encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCAParticipantTargetBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} participantId 
         * @param {SetChatBlockedBody} setChatBlockedBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSetParticipantChatBlocked: async (participantId: string, setChatBlockedBody: SetChatBlockedBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('adminCaApiSetParticipantChatBlocked', 'participantId', participantId)
            // verify required parameter 'setChatBlockedBody' is not null or undefined
            assertParamExists('adminCaApiSetParticipantChatBlocked', 'setChatBlockedBody', setChatBlockedBody)
            const localVarPath = `/admin/campus-ambassador/participant/{participant_id}/block-chat`
                .replace('{participant_id}', encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setChatBlockedBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiStartCohort: async (cohortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiStartCohort', 'cohortId', cohortId)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}/start`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {CACallTemplateBody} cACallTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateCaCallTemplate: async (templateId: string, cACallTemplateBody: CACallTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('adminCaApiUpdateCaCallTemplate', 'templateId', templateId)
            // verify required parameter 'cACallTemplateBody' is not null or undefined
            assertParamExists('adminCaApiUpdateCaCallTemplate', 'cACallTemplateBody', cACallTemplateBody)
            const localVarPath = `/admin/campus-ambassador/call/template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cACallTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {UpdateCACohortBody} updateCACohortBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateCohort: async (cohortId: string, updateCACohortBody: UpdateCACohortBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cohortId' is not null or undefined
            assertParamExists('adminCaApiUpdateCohort', 'cohortId', cohortId)
            // verify required parameter 'updateCACohortBody' is not null or undefined
            assertParamExists('adminCaApiUpdateCohort', 'updateCACohortBody', updateCACohortBody)
            const localVarPath = `/admin/campus-ambassador/cohort/{cohort_id}`
                .replace('{cohort_id}', encodeURIComponent(String(cohortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCACohortBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} announcementId 
         * @param {UpdateCAAnnouncementBody} updateCAAnnouncementBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateCohortAnnouncement: async (announcementId: string, updateCAAnnouncementBody: UpdateCAAnnouncementBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'announcementId' is not null or undefined
            assertParamExists('adminCaApiUpdateCohortAnnouncement', 'announcementId', announcementId)
            // verify required parameter 'updateCAAnnouncementBody' is not null or undefined
            assertParamExists('adminCaApiUpdateCohortAnnouncement', 'updateCAAnnouncementBody', updateCAAnnouncementBody)
            const localVarPath = `/admin/campus-ambassador/announcement/{announcement_id}`
                .replace('{announcement_id}', encodeURIComponent(String(announcementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCAAnnouncementBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} participantId 
         * @param {UpdateCAParticipantStatusBody} updateCAParticipantStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateParticipantStatus: async (participantId: string, updateCAParticipantStatusBody: UpdateCAParticipantStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('adminCaApiUpdateParticipantStatus', 'participantId', participantId)
            // verify required parameter 'updateCAParticipantStatusBody' is not null or undefined
            assertParamExists('adminCaApiUpdateParticipantStatus', 'updateCAParticipantStatusBody', updateCAParticipantStatusBody)
            const localVarPath = `/admin/campus-ambassador/participant/{participant_id}/status`
                .replace('{participant_id}', encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCAParticipantStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCaApiApi - functional programming interface
 */
export const AdminCaApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCaApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdminBroadcastCAChatBody} adminBroadcastCAChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiAdminBroadcastCaChat(adminBroadcastCAChatBody: AdminBroadcastCAChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CABroadcastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiAdminBroadcastCaChat(adminBroadcastCAChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiAdminBroadcastCaChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminSendCAChatBody} adminSendCAChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiAdminSendCaChat(adminSendCAChatBody: AdminSendCAChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CASendCAChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiAdminSendCaChat(adminSendCAChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiAdminSendCaChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {BroadcastCABody} broadcastCABody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiBroadcastCa(cohortId: string, broadcastCABody: BroadcastCABody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CABroadcastResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiBroadcastCa(cohortId, broadcastCABody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiBroadcastCa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interviewId 
         * @param {CancelCACallBody} cancelCACallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiCancelCaCall(interviewId: string, cancelCACallBody: CancelCACallBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CACallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiCancelCaCall(interviewId, cancelCACallBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiCancelCaCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiCloseApplications(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiCloseApplications(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiCloseApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CACallTemplateBody} cACallTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiCreateCaCallTemplate(cACallTemplateBody: CACallTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CACallTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiCreateCaCallTemplate(cACallTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiCreateCaCallTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCACohortBody} createCACohortBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiCreateCohort(createCACohortBody: CreateCACohortBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCACohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiCreateCohort(createCACohortBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiCreateCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiDeleteCaCallTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiDeleteCaCallTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiDeleteCaCallTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiDeleteCohort(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiDeleteCohort(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiDeleteCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {FinalizeSelectionBody} finalizeSelectionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiFinalizeSelection(cohortId: string, finalizeSelectionBody: FinalizeSelectionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiFinalizeSelection(cohortId, finalizeSelectionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiFinalizeSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} caChatId 
         * @param {string | null} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiGetCaChatMessagesAdmin(caChatId: string, cursor?: string | null, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAChatMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiGetCaChatMessagesAdmin(caChatId, cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiGetCaChatMessagesAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiGetCohort(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCACohortResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiGetCohort(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiGetCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiListCaCallTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CACallTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiListCaCallTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiListCaCallTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiListCaChatThreads(cohortId: string, page?: number, pageSize?: number, search?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAChatThreadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiListCaChatThreads(cohortId, page, pageSize, search, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiListCaChatThreads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiListCohortAnnouncements(cohortId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAAnnouncementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiListCohortAnnouncements(cohortId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiListCohortAnnouncements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiListCohortApplicants(cohortId: string, page?: number, pageSize?: number, status?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCAParticipantListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiListCohortApplicants(cohortId, page, pageSize, status, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiListCohortApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiListCohorts(page?: number, pageSize?: number, status?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCACohortListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiListCohorts(page, pageSize, status, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiListCohorts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} participantId 
         * @param {NudgeParticipantBody} nudgeParticipantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiNudgeParticipant(participantId: string, nudgeParticipantBody: NudgeParticipantBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CABroadcastResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiNudgeParticipant(participantId, nudgeParticipantBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiNudgeParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiOpenApplications(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiOpenApplications(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiOpenApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiOverallLeaderboardAdmin(cohortId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCALeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiOverallLeaderboardAdmin(cohortId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiOverallLeaderboardAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ScheduleCACallBody} scheduleCACallBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiScheduleCaCall(scheduleCACallBody: ScheduleCACallBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CACallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiScheduleCaCall(scheduleCACallBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiScheduleCaCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiScoreCohortApplicants(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiScoreCohortApplicants(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiScoreCohortApplicants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendCAAvailabilityBody} sendCAAvailabilityBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiSendCaAvailability(sendCAAvailabilityBody: SendCAAvailabilityBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendCAAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiSendCaAvailability(sendCAAvailabilityBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiSendCaAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {SendSelectionMessagesBody} sendSelectionMessagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiSendSelectionEmails(cohortId: string, sendSelectionMessagesBody: SendSelectionMessagesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiSendSelectionEmails(cohortId, sendSelectionMessagesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiSendSelectionEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {SendSelectionMessagesBody} sendSelectionMessagesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiSendSelectionWhatsapp(cohortId: string, sendSelectionMessagesBody: SendSelectionMessagesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiSendSelectionWhatsapp(cohortId, sendSelectionMessagesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiSendSelectionWhatsapp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendTestWhatsappBody} sendTestWhatsappBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiSendTestWhatsapp(sendTestWhatsappBody: SendTestWhatsappBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiSendTestWhatsapp(sendTestWhatsappBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiSendTestWhatsapp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {UpdateCAParticipantTargetBody} updateCAParticipantTargetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiSetCohortCertificateTarget(cohortId: string, updateCAParticipantTargetBody: UpdateCAParticipantTargetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiSetCohortCertificateTarget(cohortId, updateCAParticipantTargetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiSetCohortCertificateTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} participantId 
         * @param {UpdateCAParticipantTargetBody} updateCAParticipantTargetBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiSetParticipantCertificateTarget(participantId: string, updateCAParticipantTargetBody: UpdateCAParticipantTargetBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiSetParticipantCertificateTarget(participantId, updateCAParticipantTargetBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiSetParticipantCertificateTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} participantId 
         * @param {SetChatBlockedBody} setChatBlockedBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiSetParticipantChatBlocked(participantId: string, setChatBlockedBody: SetChatBlockedBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAParticipantChatBlockedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiSetParticipantChatBlocked(participantId, setChatBlockedBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiSetParticipantChatBlocked']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiStartCohort(cohortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiStartCohort(cohortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiStartCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {CACallTemplateBody} cACallTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiUpdateCaCallTemplate(templateId: string, cACallTemplateBody: CACallTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CACallTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiUpdateCaCallTemplate(templateId, cACallTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiUpdateCaCallTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} cohortId 
         * @param {UpdateCACohortBody} updateCACohortBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiUpdateCohort(cohortId: string, updateCACohortBody: UpdateCACohortBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiUpdateCohort(cohortId, updateCACohortBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiUpdateCohort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} announcementId 
         * @param {UpdateCAAnnouncementBody} updateCAAnnouncementBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiUpdateCohortAnnouncement(announcementId: string, updateCAAnnouncementBody: UpdateCAAnnouncementBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCAAnnouncementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiUpdateCohortAnnouncement(announcementId, updateCAAnnouncementBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiUpdateCohortAnnouncement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} participantId 
         * @param {UpdateCAParticipantStatusBody} updateCAParticipantStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCaApiUpdateParticipantStatus(participantId: string, updateCAParticipantStatusBody: UpdateCAParticipantStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCaApiUpdateParticipantStatus(participantId, updateCAParticipantStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCaApiApi.adminCaApiUpdateParticipantStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCaApiApi - factory interface
 */
export const AdminCaApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCaApiApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiAdminBroadcastCaChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiAdminBroadcastCaChat(requestParameters: AdminCaApiApiAdminCaApiAdminBroadcastCaChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<CABroadcastResponse> {
            return localVarFp.adminCaApiAdminBroadcastCaChat(requestParameters.adminBroadcastCAChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiAdminSendCaChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiAdminSendCaChat(requestParameters: AdminCaApiApiAdminCaApiAdminSendCaChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<CASendCAChatResponse> {
            return localVarFp.adminCaApiAdminSendCaChat(requestParameters.adminSendCAChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiBroadcastCaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiBroadcastCa(requestParameters: AdminCaApiApiAdminCaApiBroadcastCaRequest, options?: RawAxiosRequestConfig): AxiosPromise<CABroadcastResultResponse> {
            return localVarFp.adminCaApiBroadcastCa(requestParameters.cohortId, requestParameters.broadcastCABody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiCancelCaCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCancelCaCall(requestParameters: AdminCaApiApiAdminCaApiCancelCaCallRequest, options?: RawAxiosRequestConfig): AxiosPromise<CACallResponse> {
            return localVarFp.adminCaApiCancelCaCall(requestParameters.interviewId, requestParameters.cancelCACallBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiCloseApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCloseApplications(requestParameters: AdminCaApiApiAdminCaApiCloseApplicationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiCloseApplications(requestParameters.cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiCreateCaCallTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCreateCaCallTemplate(requestParameters: AdminCaApiApiAdminCaApiCreateCaCallTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CACallTemplateResponse> {
            return localVarFp.adminCaApiCreateCaCallTemplate(requestParameters.cACallTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiCreateCohortRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiCreateCohort(requestParameters: AdminCaApiApiAdminCaApiCreateCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCACohortResponse> {
            return localVarFp.adminCaApiCreateCohort(requestParameters.createCACohortBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiDeleteCaCallTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiDeleteCaCallTemplate(requestParameters: AdminCaApiApiAdminCaApiDeleteCaCallTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiDeleteCaCallTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiDeleteCohortRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiDeleteCohort(requestParameters: AdminCaApiApiAdminCaApiDeleteCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiDeleteCohort(requestParameters.cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiFinalizeSelectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiFinalizeSelection(requestParameters: AdminCaApiApiAdminCaApiFinalizeSelectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiFinalizeSelection(requestParameters.cohortId, requestParameters.finalizeSelectionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiGetCaChatMessagesAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiGetCaChatMessagesAdmin(requestParameters: AdminCaApiApiAdminCaApiGetCaChatMessagesAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCAChatMessagesResponse> {
            return localVarFp.adminCaApiGetCaChatMessagesAdmin(requestParameters.caChatId, requestParameters.cursor, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiGetCohortRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiGetCohort(requestParameters: AdminCaApiApiAdminCaApiGetCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCACohortResponse> {
            return localVarFp.adminCaApiGetCohort(requestParameters.cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCaCallTemplates(options?: RawAxiosRequestConfig): AxiosPromise<CACallTemplateListResponse> {
            return localVarFp.adminCaApiListCaCallTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiListCaChatThreadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCaChatThreads(requestParameters: AdminCaApiApiAdminCaApiListCaChatThreadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCAChatThreadsResponse> {
            return localVarFp.adminCaApiListCaChatThreads(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiListCohortAnnouncementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCohortAnnouncements(requestParameters: AdminCaApiApiAdminCaApiListCohortAnnouncementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCAAnnouncementsResponse> {
            return localVarFp.adminCaApiListCohortAnnouncements(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiListCohortApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCohortApplicants(requestParameters: AdminCaApiApiAdminCaApiListCohortApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCAParticipantListResponse> {
            return localVarFp.adminCaApiListCohortApplicants(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiListCohortsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiListCohorts(requestParameters: AdminCaApiApiAdminCaApiListCohortsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCACohortListResponse> {
            return localVarFp.adminCaApiListCohorts(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiNudgeParticipantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiNudgeParticipant(requestParameters: AdminCaApiApiAdminCaApiNudgeParticipantRequest, options?: RawAxiosRequestConfig): AxiosPromise<CABroadcastResultResponse> {
            return localVarFp.adminCaApiNudgeParticipant(requestParameters.participantId, requestParameters.nudgeParticipantBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiOpenApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiOpenApplications(requestParameters: AdminCaApiApiAdminCaApiOpenApplicationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiOpenApplications(requestParameters.cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiOverallLeaderboardAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiOverallLeaderboardAdmin(requestParameters: AdminCaApiApiAdminCaApiOverallLeaderboardAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCALeaderboardResponse> {
            return localVarFp.adminCaApiOverallLeaderboardAdmin(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiScheduleCaCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiScheduleCaCall(requestParameters: AdminCaApiApiAdminCaApiScheduleCaCallRequest, options?: RawAxiosRequestConfig): AxiosPromise<CACallResponse> {
            return localVarFp.adminCaApiScheduleCaCall(requestParameters.scheduleCACallBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiScoreCohortApplicantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiScoreCohortApplicants(requestParameters: AdminCaApiApiAdminCaApiScoreCohortApplicantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiScoreCohortApplicants(requestParameters.cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiSendCaAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendCaAvailability(requestParameters: AdminCaApiApiAdminCaApiSendCaAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendCAAvailabilityResponse> {
            return localVarFp.adminCaApiSendCaAvailability(requestParameters.sendCAAvailabilityBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiSendSelectionEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendSelectionEmails(requestParameters: AdminCaApiApiAdminCaApiSendSelectionEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiSendSelectionEmails(requestParameters.cohortId, requestParameters.sendSelectionMessagesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiSendSelectionWhatsappRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendSelectionWhatsapp(requestParameters: AdminCaApiApiAdminCaApiSendSelectionWhatsappRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiSendSelectionWhatsapp(requestParameters.cohortId, requestParameters.sendSelectionMessagesBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiSendTestWhatsappRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSendTestWhatsapp(requestParameters: AdminCaApiApiAdminCaApiSendTestWhatsappRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiSendTestWhatsapp(requestParameters.sendTestWhatsappBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiSetCohortCertificateTargetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSetCohortCertificateTarget(requestParameters: AdminCaApiApiAdminCaApiSetCohortCertificateTargetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiSetCohortCertificateTarget(requestParameters.cohortId, requestParameters.updateCAParticipantTargetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiSetParticipantCertificateTargetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSetParticipantCertificateTarget(requestParameters: AdminCaApiApiAdminCaApiSetParticipantCertificateTargetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiSetParticipantCertificateTarget(requestParameters.participantId, requestParameters.updateCAParticipantTargetBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiSetParticipantChatBlockedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiSetParticipantChatBlocked(requestParameters: AdminCaApiApiAdminCaApiSetParticipantChatBlockedRequest, options?: RawAxiosRequestConfig): AxiosPromise<CAParticipantChatBlockedResponse> {
            return localVarFp.adminCaApiSetParticipantChatBlocked(requestParameters.participantId, requestParameters.setChatBlockedBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiStartCohortRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiStartCohort(requestParameters: AdminCaApiApiAdminCaApiStartCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiStartCohort(requestParameters.cohortId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiUpdateCaCallTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateCaCallTemplate(requestParameters: AdminCaApiApiAdminCaApiUpdateCaCallTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CACallTemplateResponse> {
            return localVarFp.adminCaApiUpdateCaCallTemplate(requestParameters.templateId, requestParameters.cACallTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiUpdateCohortRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateCohort(requestParameters: AdminCaApiApiAdminCaApiUpdateCohortRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiUpdateCohort(requestParameters.cohortId, requestParameters.updateCACohortBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiUpdateCohortAnnouncementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateCohortAnnouncement(requestParameters: AdminCaApiApiAdminCaApiUpdateCohortAnnouncementRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCAAnnouncementResponse> {
            return localVarFp.adminCaApiUpdateCohortAnnouncement(requestParameters.announcementId, requestParameters.updateCAAnnouncementBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCaApiApiAdminCaApiUpdateParticipantStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCaApiUpdateParticipantStatus(requestParameters: AdminCaApiApiAdminCaApiUpdateParticipantStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.adminCaApiUpdateParticipantStatus(requestParameters.participantId, requestParameters.updateCAParticipantStatusBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCaApiAdminBroadcastCaChat operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiAdminBroadcastCaChatRequest {
    readonly adminBroadcastCAChatBody: AdminBroadcastCAChatBody
}

/**
 * Request parameters for adminCaApiAdminSendCaChat operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiAdminSendCaChatRequest {
    readonly adminSendCAChatBody: AdminSendCAChatBody
}

/**
 * Request parameters for adminCaApiBroadcastCa operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiBroadcastCaRequest {
    readonly cohortId: string

    readonly broadcastCABody: BroadcastCABody
}

/**
 * Request parameters for adminCaApiCancelCaCall operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiCancelCaCallRequest {
    readonly interviewId: string

    readonly cancelCACallBody: CancelCACallBody
}

/**
 * Request parameters for adminCaApiCloseApplications operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiCloseApplicationsRequest {
    readonly cohortId: string
}

/**
 * Request parameters for adminCaApiCreateCaCallTemplate operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiCreateCaCallTemplateRequest {
    readonly cACallTemplateBody: CACallTemplateBody
}

/**
 * Request parameters for adminCaApiCreateCohort operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiCreateCohortRequest {
    readonly createCACohortBody: CreateCACohortBody
}

/**
 * Request parameters for adminCaApiDeleteCaCallTemplate operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiDeleteCaCallTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for adminCaApiDeleteCohort operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiDeleteCohortRequest {
    readonly cohortId: string
}

/**
 * Request parameters for adminCaApiFinalizeSelection operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiFinalizeSelectionRequest {
    readonly cohortId: string

    readonly finalizeSelectionBody: FinalizeSelectionBody
}

/**
 * Request parameters for adminCaApiGetCaChatMessagesAdmin operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiGetCaChatMessagesAdminRequest {
    readonly caChatId: string

    readonly cursor?: string | null

    readonly pageSize?: number
}

/**
 * Request parameters for adminCaApiGetCohort operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiGetCohortRequest {
    readonly cohortId: string
}

/**
 * Request parameters for adminCaApiListCaChatThreads operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiListCaChatThreadsRequest {
    readonly cohortId: string

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for adminCaApiListCohortAnnouncements operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiListCohortAnnouncementsRequest {
    readonly cohortId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminCaApiListCohortApplicants operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiListCohortApplicantsRequest {
    readonly cohortId: string

    readonly page?: number

    readonly pageSize?: number

    readonly status?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for adminCaApiListCohorts operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiListCohortsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly status?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for adminCaApiNudgeParticipant operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiNudgeParticipantRequest {
    readonly participantId: string

    readonly nudgeParticipantBody: NudgeParticipantBody
}

/**
 * Request parameters for adminCaApiOpenApplications operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiOpenApplicationsRequest {
    readonly cohortId: string
}

/**
 * Request parameters for adminCaApiOverallLeaderboardAdmin operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiOverallLeaderboardAdminRequest {
    readonly cohortId: string

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminCaApiScheduleCaCall operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiScheduleCaCallRequest {
    readonly scheduleCACallBody: ScheduleCACallBody
}

/**
 * Request parameters for adminCaApiScoreCohortApplicants operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiScoreCohortApplicantsRequest {
    readonly cohortId: string
}

/**
 * Request parameters for adminCaApiSendCaAvailability operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiSendCaAvailabilityRequest {
    readonly sendCAAvailabilityBody: SendCAAvailabilityBody
}

/**
 * Request parameters for adminCaApiSendSelectionEmails operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiSendSelectionEmailsRequest {
    readonly cohortId: string

    readonly sendSelectionMessagesBody: SendSelectionMessagesBody
}

/**
 * Request parameters for adminCaApiSendSelectionWhatsapp operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiSendSelectionWhatsappRequest {
    readonly cohortId: string

    readonly sendSelectionMessagesBody: SendSelectionMessagesBody
}

/**
 * Request parameters for adminCaApiSendTestWhatsapp operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiSendTestWhatsappRequest {
    readonly sendTestWhatsappBody: SendTestWhatsappBody
}

/**
 * Request parameters for adminCaApiSetCohortCertificateTarget operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiSetCohortCertificateTargetRequest {
    readonly cohortId: string

    readonly updateCAParticipantTargetBody: UpdateCAParticipantTargetBody
}

/**
 * Request parameters for adminCaApiSetParticipantCertificateTarget operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiSetParticipantCertificateTargetRequest {
    readonly participantId: string

    readonly updateCAParticipantTargetBody: UpdateCAParticipantTargetBody
}

/**
 * Request parameters for adminCaApiSetParticipantChatBlocked operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiSetParticipantChatBlockedRequest {
    readonly participantId: string

    readonly setChatBlockedBody: SetChatBlockedBody
}

/**
 * Request parameters for adminCaApiStartCohort operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiStartCohortRequest {
    readonly cohortId: string
}

/**
 * Request parameters for adminCaApiUpdateCaCallTemplate operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiUpdateCaCallTemplateRequest {
    readonly templateId: string

    readonly cACallTemplateBody: CACallTemplateBody
}

/**
 * Request parameters for adminCaApiUpdateCohort operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiUpdateCohortRequest {
    readonly cohortId: string

    readonly updateCACohortBody: UpdateCACohortBody
}

/**
 * Request parameters for adminCaApiUpdateCohortAnnouncement operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiUpdateCohortAnnouncementRequest {
    readonly announcementId: string

    readonly updateCAAnnouncementBody: UpdateCAAnnouncementBody
}

/**
 * Request parameters for adminCaApiUpdateParticipantStatus operation in AdminCaApiApi.
 */
export interface AdminCaApiApiAdminCaApiUpdateParticipantStatusRequest {
    readonly participantId: string

    readonly updateCAParticipantStatusBody: UpdateCAParticipantStatusBody
}

/**
 * AdminCaApiApi - object-oriented interface
 */
export class AdminCaApiApi extends BaseAPI {
    /**
     * 
     * @param {AdminCaApiApiAdminCaApiAdminBroadcastCaChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiAdminBroadcastCaChat(requestParameters: AdminCaApiApiAdminCaApiAdminBroadcastCaChatRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiAdminBroadcastCaChat(requestParameters.adminBroadcastCAChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiAdminSendCaChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiAdminSendCaChat(requestParameters: AdminCaApiApiAdminCaApiAdminSendCaChatRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiAdminSendCaChat(requestParameters.adminSendCAChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiBroadcastCaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiBroadcastCa(requestParameters: AdminCaApiApiAdminCaApiBroadcastCaRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiBroadcastCa(requestParameters.cohortId, requestParameters.broadcastCABody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiCancelCaCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiCancelCaCall(requestParameters: AdminCaApiApiAdminCaApiCancelCaCallRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiCancelCaCall(requestParameters.interviewId, requestParameters.cancelCACallBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiCloseApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiCloseApplications(requestParameters: AdminCaApiApiAdminCaApiCloseApplicationsRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiCloseApplications(requestParameters.cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiCreateCaCallTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiCreateCaCallTemplate(requestParameters: AdminCaApiApiAdminCaApiCreateCaCallTemplateRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiCreateCaCallTemplate(requestParameters.cACallTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiCreateCohortRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiCreateCohort(requestParameters: AdminCaApiApiAdminCaApiCreateCohortRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiCreateCohort(requestParameters.createCACohortBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiDeleteCaCallTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiDeleteCaCallTemplate(requestParameters: AdminCaApiApiAdminCaApiDeleteCaCallTemplateRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiDeleteCaCallTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiDeleteCohortRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiDeleteCohort(requestParameters: AdminCaApiApiAdminCaApiDeleteCohortRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiDeleteCohort(requestParameters.cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiFinalizeSelectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiFinalizeSelection(requestParameters: AdminCaApiApiAdminCaApiFinalizeSelectionRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiFinalizeSelection(requestParameters.cohortId, requestParameters.finalizeSelectionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiGetCaChatMessagesAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiGetCaChatMessagesAdmin(requestParameters: AdminCaApiApiAdminCaApiGetCaChatMessagesAdminRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiGetCaChatMessagesAdmin(requestParameters.caChatId, requestParameters.cursor, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiGetCohortRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiGetCohort(requestParameters: AdminCaApiApiAdminCaApiGetCohortRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiGetCohort(requestParameters.cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiListCaCallTemplates(options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiListCaCallTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiListCaChatThreadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiListCaChatThreads(requestParameters: AdminCaApiApiAdminCaApiListCaChatThreadsRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiListCaChatThreads(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiListCohortAnnouncementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiListCohortAnnouncements(requestParameters: AdminCaApiApiAdminCaApiListCohortAnnouncementsRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiListCohortAnnouncements(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiListCohortApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiListCohortApplicants(requestParameters: AdminCaApiApiAdminCaApiListCohortApplicantsRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiListCohortApplicants(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiListCohortsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiListCohorts(requestParameters: AdminCaApiApiAdminCaApiListCohortsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiListCohorts(requestParameters.page, requestParameters.pageSize, requestParameters.status, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiNudgeParticipantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiNudgeParticipant(requestParameters: AdminCaApiApiAdminCaApiNudgeParticipantRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiNudgeParticipant(requestParameters.participantId, requestParameters.nudgeParticipantBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiOpenApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiOpenApplications(requestParameters: AdminCaApiApiAdminCaApiOpenApplicationsRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiOpenApplications(requestParameters.cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiOverallLeaderboardAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiOverallLeaderboardAdmin(requestParameters: AdminCaApiApiAdminCaApiOverallLeaderboardAdminRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiOverallLeaderboardAdmin(requestParameters.cohortId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiScheduleCaCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiScheduleCaCall(requestParameters: AdminCaApiApiAdminCaApiScheduleCaCallRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiScheduleCaCall(requestParameters.scheduleCACallBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiScoreCohortApplicantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiScoreCohortApplicants(requestParameters: AdminCaApiApiAdminCaApiScoreCohortApplicantsRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiScoreCohortApplicants(requestParameters.cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiSendCaAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiSendCaAvailability(requestParameters: AdminCaApiApiAdminCaApiSendCaAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiSendCaAvailability(requestParameters.sendCAAvailabilityBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiSendSelectionEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiSendSelectionEmails(requestParameters: AdminCaApiApiAdminCaApiSendSelectionEmailsRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiSendSelectionEmails(requestParameters.cohortId, requestParameters.sendSelectionMessagesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiSendSelectionWhatsappRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiSendSelectionWhatsapp(requestParameters: AdminCaApiApiAdminCaApiSendSelectionWhatsappRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiSendSelectionWhatsapp(requestParameters.cohortId, requestParameters.sendSelectionMessagesBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiSendTestWhatsappRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiSendTestWhatsapp(requestParameters: AdminCaApiApiAdminCaApiSendTestWhatsappRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiSendTestWhatsapp(requestParameters.sendTestWhatsappBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiSetCohortCertificateTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiSetCohortCertificateTarget(requestParameters: AdminCaApiApiAdminCaApiSetCohortCertificateTargetRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiSetCohortCertificateTarget(requestParameters.cohortId, requestParameters.updateCAParticipantTargetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiSetParticipantCertificateTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiSetParticipantCertificateTarget(requestParameters: AdminCaApiApiAdminCaApiSetParticipantCertificateTargetRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiSetParticipantCertificateTarget(requestParameters.participantId, requestParameters.updateCAParticipantTargetBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiSetParticipantChatBlockedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiSetParticipantChatBlocked(requestParameters: AdminCaApiApiAdminCaApiSetParticipantChatBlockedRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiSetParticipantChatBlocked(requestParameters.participantId, requestParameters.setChatBlockedBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiStartCohortRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiStartCohort(requestParameters: AdminCaApiApiAdminCaApiStartCohortRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiStartCohort(requestParameters.cohortId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiUpdateCaCallTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiUpdateCaCallTemplate(requestParameters: AdminCaApiApiAdminCaApiUpdateCaCallTemplateRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiUpdateCaCallTemplate(requestParameters.templateId, requestParameters.cACallTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiUpdateCohortRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiUpdateCohort(requestParameters: AdminCaApiApiAdminCaApiUpdateCohortRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiUpdateCohort(requestParameters.cohortId, requestParameters.updateCACohortBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiUpdateCohortAnnouncementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiUpdateCohortAnnouncement(requestParameters: AdminCaApiApiAdminCaApiUpdateCohortAnnouncementRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiUpdateCohortAnnouncement(requestParameters.announcementId, requestParameters.updateCAAnnouncementBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCaApiApiAdminCaApiUpdateParticipantStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCaApiUpdateParticipantStatus(requestParameters: AdminCaApiApiAdminCaApiUpdateParticipantStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminCaApiApiFp(this.configuration).adminCaApiUpdateParticipantStatus(requestParameters.participantId, requestParameters.updateCAParticipantStatusBody, options).then((request) => request(this.axios, this.basePath));
    }
}

